import { fork, all, call, put, takeLatest, takeEvery, select } from 'redux-saga/effects'
import { delay } from 'redux-saga'
import {
    GET_CART,
    GET_CART_SUCCESS,
    GET_CART_ERROR,
    ADD_TO_CART,
    ADD_TO_CART_ERROR,
    ADD_TO_CART_SUCCESS,
    ADD_TO_CART_RESET
} from "../../actions"
import {getToken, getCSRFToken, getUniversalMenuApiUrls, getUniversalMenuHeader, getIsAuthenticated} from "../../selectors"
import {fetchEveJsonData, postEveAddToBagJsonData} from '../../api'

function* addToCart(action) {
    try
    {
        const isAuthenticated = yield select(getIsAuthenticated);
        const {account: {url}} = yield select(getUniversalMenuHeader);
        // Redirect to the login page if they are not authenticated
        if(!isAuthenticated) {
            window.location.href = url;
            return;
        }

        const token = yield select(getToken);
        const csrfToken = yield select(getCSRFToken);
        const api = yield select(getUniversalMenuApiUrls);

        window.localStorage.setItem("ngStorage-notify_ti_cart_update", {
            status: "updated",
            count: 0,
            time: new Date().getTime(),
            window_id: Math.floor(Math.random() * 10000) + '_' + new Date().getTime()
        });

        var formData = '';
        if(csrfToken)
            formData = 'YII_CSRF_TOKEN=' + csrfToken + '&';
        formData += 'skus=' + action.payload.simpleSku;

        var response = yield call(postEveAddToBagJsonData, api.add_to_cart, token, formData, 'POST', 'same-origin' );
        yield put({type: ADD_TO_CART_SUCCESS, payload: {response, ...action.payload}});
        yield put({type: GET_CART});

    } catch (e) {
        console.error(e);
        yield put({type: ADD_TO_CART_ERROR, payload: action.payload, message: e.message});
    }

    yield delay(2000)
    yield put({type: ADD_TO_CART_RESET, payload: action.payload});
}


export function* addToCartSaga() {
    yield takeEvery(ADD_TO_CART, addToCart);
}

function* fetchCart(action) {
    try
    {
        const token = yield select(getToken);
        const api = yield select(getUniversalMenuApiUrls);
        const cart = yield call(fetchEveJsonData, api.get_cart, token);
        yield put({type: GET_CART_SUCCESS, payload: cart});
    } catch (e) {
        console.error(e);
        yield put({type: GET_CART_ERROR, message: e.message});
    }
}

export function* fetchCartSaga() {
    yield takeLatest(GET_CART, fetchCart);
}


function* cartSaga() {
    yield all([
        fork(fetchCartSaga),
        fork(addToCartSaga)
    ])
}

export default cartSaga;


// WEBPACK FOOTER //
// ./src/sagas/account/cart.js